<template>
    <div>
<!--        {{extra}}-->
        <span class="timeline-key">Visa Fee (USD) </span>: $ {{extra.amount}}
        <span class="timeline-key ml-2">Late Fee (USD) </span>: $ {{extra.late_stay_cost}}
        <span v-if="extra.penalty && extra.penalty >0"><span class="timeline-key ml-2">Penalty Fee (USD) </span>: $ {{extra.penalty}}</span>
        <span v-if="extra.exempt_cost && extra.exempt_cost >0"><span class="timeline-key ml-2">Exempted Fee (USD) </span>: $ {{extra.exempt_cost}}</span>
        <span class="timeline-key ml-2" >Total Fee (USD) </span>: $ {{extra.total}}<br>

        <div v-html="extra.content"></div>
        <div v-if="extra.voucher_number">
            <span class="timeline-key">Voucher Number  </span>: {{extra.voucher_number}} <br>
        </div>
        <span class="timeline-key">Malenika Voucher Description  </span>: {{extra.description}} <br>
    </div>
</template>

<script>

    export default {
        name: "VoucherGenerated",
        props: ['extra', 'user']
    }
</script>
